"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var TWSlider_1 = require("../classes/TWSlider");
var MetricsSection = /** @class */ (function () {
    function MetricsSection() {
    }
    MetricsSection.prototype.onLoadEach = function ($element) {
        var isSlider = $element.dataset.slider == "yes";
        if (!isSlider)
            return;
        var $wrap = $element.$(".row");
        this.slider = new TWSlider_1["default"](".MetricsSection__items", $wrap, 1, {
            cellAlign: "left",
            cellSelector: ".item",
            contain: true,
            draggable: true,
            prevNextButtons: false,
            watchCSS: true
        });
    };
    MetricsSection = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".MetricsSection__items",
            isElementArray: true
        })
    ], MetricsSection);
    return MetricsSection;
}());
new MetricsSection();
